import { render } from "./PracticeChapters.vue?vue&type=template&id=7998bfaf&scoped=true"
import script from "./PracticeChapters.vue?vue&type=script&lang=js"
export * from "./PracticeChapters.vue?vue&type=script&lang=js"

import "./PracticeChapters.vue?vue&type=style&index=0&id=7998bfaf&scoped=true&lang=css"

import exportComponent from "/Users/jipfens/Library/Mobile Documents/com~apple~CloudDocs/iProjects/lexis/lexis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7998bfaf"]])

export default __exports__